<template>
  <v-layout 
    align-center 
    justify-center
    class="text-xs-center">
    <v-flex xs12>
      <v-card
        max-width="450"
        style="margin: auto;"
        class="text-xs-center roundedcard py-3 px-3"
        color="rgba(255, 255, 255, 0.1)">
        <v-card-text class="mb-1">
          <span class="animated zoomInLeft headline font-weight-bold text-xs-center white--text">
            Welcome to
          </span>

          <v-img
            class="animated zoomInRight wevent_icon"
            contain
            :src="require('@/assets/TextWeVent_thumbnail_beta.svg')"></v-img>
            <!-- :src="require('@/assets/Wevent_Logo_only_text_black.svg')"></v-img> -->
            
            <!-- <p class="display-1 text-xs-center white--text">Login</p> -->
        </v-card-text>
        

        <!-- <v-card-text> -->
        <form @submit.prevent="onSignup">
          <v-window v-model="step">
            <v-window-item 
              :value="1">
              <div class="mb-1 caption white--text text-xs-left">
                Dein Namen dient dazu, dass andere User dich finden können
              </div>
              <v-text-field 
                v-model.trim="name"
                autocomplete="username"
                :style="$v.name.$error ? '' : '-webkit-text-fill-color: #fff;'"
                label="Name"
                append-icon="fas fa-question-circle"

                name="name"
                type="text"
                dark
                outline
                :error-messages="nameErrors"
                @change="$v.name.$touch()"
                @blur="$v.name.$touch()"
                @click:append="whyName = true"></v-text-field>

              <v-dialog 
                v-model="whyName" 
                scrollable
                max-width="300">
                <v-card class="roundedcard">
                  <v-card-title>
                    <span 
                      class="secondary--text ">
                      Warum soll ich einen Namen angeben?
                    </span>
                  </v-card-title>
    
                  <v-card-text>
                    <p class="caption">
                      Mit diesem Namen interagierst du auf WeVent. Mit diesen Namen können dich andere User suchen und auch du kannst damit andere User finden. Damit andere User dich finden können ist es sinnvoll deinen echten Namen zu verwenden. Da es sich bei "Wevent" um eine soziale Plattform handelt und es vorallem darum geht sich im echten Leben zu verabreden und miteinander tolle Momente zu erleben, würdest du den Sinn verfehlen dich hier mit einem falschen Namen anzumelden!
                      Dein Namen kann im Nachhinein im Profil geändert werden. Jedoch nur in einem Abstand von 3 Monaten. Dies verfolgt den Zweck, dass dich deine Mitnutzer nicht mit ständig neuen Namen verwirren.
                      Weitere Details findest du in unserer Datenrichtlinie.
                    </p>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn 
                      color="primary" 
                      small
                      flat="flat" 
                      @click="whyName = false">
                      OK
                    </v-btn>
                    <!-- @click="termsDialog = false">OK</v-btn> -->
                  </v-card-actions>
                </v-card>
              </v-dialog>

              <div class="mb-1 caption white--text text-xs-left">
                Mit dieser Email meldest du dich bei Wevent an
              </div>
              <v-text-field 
                v-model="email"
                autocomplete="username"
                :style="$v.email.$error ? '' : '-webkit-text-fill-color: #fff;'"
                label="Email"
                name="email"
                type="email"
                append-icon="fas fa-question-circle"
                dark
                outline
                :error-messages="emailErrors"
                @change="$v.email.$touch()"
                @blur="$v.email.$touch()"
                @click:append="whyEmail = true"></v-text-field>
             
              <v-checkbox 
                v-model="subscribeNewsletter"
                class="my-0 py-0"
                style="margin-left: 12px;"
                color="white"
                dark>
                <span slot="label">
                  <small>Ja, ich möchte WeVent-News per Email erhalten </small></span>
              </v-checkbox>
              <p class="font-italic white--text">
                <small>Durch deine Anmeldung stimmst Du zu, dass deine Daten gemäß der 
                  <span 
                    style="cursor: pointer"

                    class="secondary--text" 
                    @click.stop="termsDialog = true">
                    Datenschutzerklärung
                  </span>
                  verarbeitet werden. Du kannst diese Einwilligung jederzeit mit einem Klick widerrufen und Dich aus dem Newsletter austragen. </small>
              </p>
              <v-dialog 
                v-model="whyEmail" 
                scrollable
                max-width="300">
                <v-card class="roundedcard">
                  <v-card-title>
                    <span 
                      class="secondary--text ">
                      Wozu dient die Email Adresse?
                    </span>
                  </v-card-title>
    
                  <v-card-text>
                    <p class="caption">
                      Mit dieser Email Adresse meldest du dich bei deinem Wevent Account an. Sie identifiziert dich eindeutig und ist deinem Account zugewiesen. Sie wird nicht veröffentlicht und ist auch für keinen anderen User ersichtlich.
                      Du kannst deine Email Adresse in deinem Profil jederzeit ändern.
                      Weitere Details findest du in unserer Datenrichtlinie.
                    </p>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn 
                      color="primary" 
                      small
                      flat="flat" 
                      @click="whyEmail = false">
                      OK
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-window-item>
            
            <v-window-item 
              :value="2">
              <v-layout 
                class="text-xs-center"
                justify-center
                align-center
                row 
                wrap>
                <v-flex xs12>
                  <div class="mb-1 caption white--text text-xs-left">
                    Wo sollen dir Events angezeigt werden?
                  </div>
                  <v-text-field
                    id="autocomplete"
                    v-model="mylocationinput"
                    dark
                    style="padding: 20"
                    :messages="mylocationinput !== mylocation ? mylocation : ''"
                    single-line
                    outline 
                    :loading="loadingGeolocate"
                    :error-messages="mylocationinputErrors"
                    append-icon="fas fa-location"
                    prepend-inner-icon="fas fa-map-marker-alt"
                    name="Location"
                    placeholder="Location"
                    type="text"
                    @focus="initAutocomplete"
                    @click:append="initGeolocator"
                    @change="$v.mycoordinates.$touch()"
                    @blur="$v.mycoordinates.$touch()">
                  </v-text-field>
                </v-flex>
               


                <v-flex 
                  xs12>
                  <div class="mb-1 caption white--text text-xs-left">
                    Wie alt bimst du?
                  </div>
                  <v-dialog
                    id="cal"
                    ref="dialog"
                    v-model="menu"
                    full-width
                    max-width="290px">
                    <v-text-field
                      id="birthday"
                      slot="activator"
                      :value="birthday | date"
                      style="margin-bottom: -24px"
                      :error-messages="birthdayErrors"
                      name="birthday"
                      append-icon="fas fa-question-circle"
                      label="Birthday date"
                      dark
                      outline 
                      readonly
                      @click:append="whyBday = true">
                      <v-icon
                        slot="prepend-inner"
                        icon-color="white">
                        $vuetify.icons.birthdaycake
                      </v-icon>
                    </v-text-field>
                      
                    <v-date-picker
                      ref="picker"
                      v-model="birthday"
                      first-day-of-week="1"
                      class="roundedcard"
                      :max="new Date().toISOString().substr(0, 10)"
                      @input="menu = false"
                      @blur="save">
                    </v-date-picker>
                  </v-dialog>
                  <v-dialog 
                    v-model="whyBday" 
                    scrollable
                    max-width="300">
                    <v-card class="roundedcard">
                      <v-card-title>
                        <span 
                          class="secondary--text ">
                          Warum muss ich meinen Geburtstag angeben?
                        </span>
                      </v-card-title>
    
                      <v-card-text>
                        <p class="caption">
                          Die Angabe deines Geburtstags hilft dabei, dir die für dein Alter entsprechende Wevent-Erfahrung zu bieten. Wenn du ändern möchtest, wer dies sehen kann, gehe zum „Info“-Abschnitt deines Profils. Weitere Details findest du in unserer Datenrichtlinie.
                        </p>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn 
                          color="primary" 
                          small
                          flat="flat" 
                          @click="whyBday = false">
                          OK
                        </v-btn>
                        <!-- @click="termsDialog = false">OK</v-btn> -->
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-flex>

                <v-flex 
                  xs12>
                  <v-checkbox 
                    v-model="displayBDay"
                    style="margin-left: 12px;"
                    color="white"
                    dark 
                    :label="displayBDay ? 'Geburtstag im Profil anzeigen' : 'Geburtstag wird nicht angezeigt'">
                  </v-checkbox>
                
                  <!-- <v-flex>

                  <div>
                    location: {{ location }}
                  </div>
                  <div>

                    mylocationinput: {{ mylocationinput }}
                  </div>

                  <div>

                    mylocation: {{ mylocation }}
                  </div>
                  <div>

                    mycoordinates:  {{ mycoordinates }}

                  </div>
                  <div>
                    loadingGeolocate:  {{ loadingGeolocate }}
                  </div>
                </v-flex> -->
                </v-flex>
              </v-layout>
            </v-window-item>

            <v-window-item 
              :value="3">
              <v-text-field 
                v-model="password"
                :append-icon="showPw ? 'fas fa-eye' : 'fas fa-eye-slash'"
                autocomplete="current-password"
                :style="$v.password.$error ? '' : '-webkit-text-fill-color: #fff;'"
                name="password"
                :type="showPw ? 'text' : 'password'"
                dark
                outline
                :error-messages="passwordErrors"
                label="Password"
                @click:append="showPw = !showPw"
                @change="$v.password.$touch()"
                @blur="$v.password.$touch()"></v-text-field>

              <v-text-field 
                v-model="confirmPassword"
                autocomplete="current-password"
                :style="$v.confirmPassword.$error ? '' : '-webkit-text-fill-color: #fff;'"
                name="password"
                dark
                :type="showPw ? 'text' : 'password'"
                outline
                :error-messages="confirmPasswordErrors"
                label="Password"
                @change="$v.confirmPassword.$touch()"
                @blur="$v.confirmPassword.$touch()"></v-text-field>

              <div 
                class="mx-4  text-xs-left white--text caption">
                Indem du auf "Sign up" klickst, stimmst du unserer <span 
                  style="cursor: pointer"
                  class="secondary--text" 
                  @click.stop="termsDialog = true">
                  Datenschutzerklärung 
                </span> zu. In unserer <span 
                  style="cursor: pointer"

                  class="secondary--text" 
                  @click.stop="termsDialog = true">
                  Datenschutzerklärung
                </span> erfährst du, wie wir deine Daten erfassen, verwenden und teilen. 
              </div>
              
              
              <v-dialog 
                v-model="termsDialog" 
                scrollable
                width="600px">
                <app-agb @close-dialog="termsDialog = false"></app-agb>
              </v-dialog>
            </v-window-item>






            <v-window-item 
              :value="4">
              <div class="pa-0 text-xs-center">
                <v-img
                  class="mb-3"
                  contain
                  style="border-radius: 24px"
                  height="128"
                  :src="require('@/assets/Wevent_App_Icon.png')"></v-img>
                <h3 class="title font-weight-light white--text mb-2">
                  {{ signupError ? 'Ohh! Something went wrong!' : 'Account created!' }}
                </h3>
                <span class="caption accent--text text--lighten-1">
                  {{ signupError ? signUpErrorMessage : 'Thanks for signing up!' }}
                </span>
              </div>
            </v-window-item>
          </v-window>


          <v-btn 
            v-if="step <= 3"
            color="rgba(255, 255, 255, 0.8)"
            class="mt-2"
            style="width: 80%"
            :loading="loading"
            @click="next">
            {{ buttonText }}
          </v-btn>
          <!-- <v-btn 
            v-if="step === 3"
            type="submit"
            color="rgba(255, 255, 255, 0.8)"
            class="mt-2"
            style="width: 80%"
            :loading="loading"
            @click="next">
            Sign Up
          </v-btn> -->
          <v-btn 
            v-if="step === 4"
            color="rgba(255, 255, 255, 0.8)"
            class="mt-2"
            style="width: 80%"
            :loading="loading"
            @click="goBack">
            Go back
          </v-btn>
        </form>

       


        <!-- </v-card-text> -->
        <!-- <v-layout 
          align-center 
          justify-center
          class="text-xs-center">
          <v-flex xs12>
            <div class="mt-3 white--text text-xs-center">
              Do you have an Account?
            </div>

            <v-btn 
              class="mt-2"
              outline
              small
              dark
              @click.prevent="clickSignIn">
              Sign In
            </v-btn>
          </v-flex>
        </v-layout> -->
      </v-card>

      <v-layout 
        align-center 
        justify-center
        class="text-xs-center">
        <v-flex
          xs12
          class="text-xs-center mt-3">
          <div class="mt-1 white--text text-xs-center">
            Account vorhanden?
          </div>
          <v-btn
            round
            style="z-index: 5"
            color="rgba(255,255,255,0.3)"
            dark
            @click.prevent="clickSignIn">
            <v-icon
              left
              small>
              fas fa-sign-in
            </v-icon>
            Zum Login
          </v-btn>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>



<script>
/* global google */

import { mapGetters, mapMutations } from 'vuex'
import { required, email, sameAs, minLength, maxLength, helpers } from 'vuelidate/lib/validators'


import AGB from '@/components/global_comps/AGB.vue'
const regExName = helpers.regex('regExName', /^[0-9A-Za-zöÖäÄüÜß]+[0-9A-Za-z:.\s\-_öÖäÄüÜß][0-9A-Za-zöÖäÄüÜß]+$/)


export default {
  components: {
    // eslint-disable-next-line
    "app-agb": AGB
  },
  data () {
    return {
      
      step: 1,
      signupError: false,
      signUpErrorMessage: null,

      menu: false,

      name: '',
      whyName: false,

      email: '',
      whyEmail: false,
      subscribeNewsletter: false,
      
      mylocationinput: '',    
      mylocation: '',    
      mycoordinates: '',
      loadingGeolocate: false,
      autocomplete: null,
      geocoder: null,


      birthday: null,
      displayBDay: true,
      whyBday: false,

      
      showPw: false,
      password: '',
      confirmPassword: '',


      termsDialog: false,
      
    
    }
  },
  validations: {
   
    name: {
      required,
      minLength: minLength(3),
      maxLength: maxLength(30),
      regExName
    },
    email: {
      required,
      email
    },
    mylocationinput: {
      required
    },
    mylocation: {
      required
    },
    mycoordinates: {
      required
    },
    birthday: {
      required
    },
    password: {
      minLength: minLength(6),
      required
    },
    confirmPassword: {
      required,
      sameAsPassword: sameAs('password')
    }
  },
  computed: {
    buttonText() {
      if (this.step < 3) {
        return 'Next'
      } else {
        return 'Sign Up'
      }
    },
    nameErrors() {
      const errors = []
      if (!this.$v.name.$dirty) return errors
      !this.$v.name.maxLength && errors.push('Name must not have more than ' + this.$v.name.$params.maxLength.max + ' letters.')
      !this.$v.name.minLength && errors.push('Name must have at least ' + this.$v.name.$params.minLength.min + ' letters.')
      !this.$v.name.regExName && errors.push('Name must not start or end with special character or contains space.')
      !this.$v.name.required && errors.push('Name is required.')
      return errors
    },
    emailErrors() {
      const errors = []
      if (!this.$v.email.$dirty) return errors
      !this.$v.email.required && errors.push('Email is required.')
      !this.$v.email.email && errors.push('Invalid Email.')
      return errors
    },
    mylocationinputErrors() {
      const errors = []
      if (!this.$v.mycoordinates.$dirty) return errors
      !this.$v.mylocationinput.required && errors.push('Location is required.')
      !this.$v.mylocation.required && errors.push('Location is required.')
      !this.$v.mycoordinates.required && errors.push('Location is required.')
      return errors
    },
    birthdayErrors() {
      const errors = []
      if (!this.$v.birthday.$dirty) return errors
      !this.$v.birthday.required && errors.push('Birthday is required.')
      return errors
    },
    passwordErrors() {
      const errors = []
      if (!this.$v.password.$dirty) return errors
      !this.$v.password.minLength && errors.push('Password must have at least ' + this.$v.password.$params.minLength.min + ' letters.')
      !this.$v.password.required && errors.push('Password is required.')
      return errors
    },
    confirmPasswordErrors() {
      const errors = []
      if (!this.$v.password.$dirty) return errors
      !this.$v.password.required && errors.push('Please confirm the password.')
      !this.$v.confirmPassword.sameAsPassword && errors.push('Passwords do not match!')
      return errors
    },
    ...mapGetters({
      user: 'user',
      error: 'error',
      loading: 'loading'
    }),
    formIsValid() {
      return (
        !this.$v.name.$invalid &&
        !this.$v.email.$invalid &&
        !this.$v.mylocationinput.$invalid &&
        !this.$v.mylocation.$invalid &&
        !this.$v.mycoordinates.$invalid &&
        !this.$v.birthday.$invalid &&
        !this.$v.password.$invalid &&
        !this.$v.confirmPassword.$invalid
      )
    },
    
  },

  watch: {
    // user (value) {
    //   if (value !== null && value !== undefined) {
    //     console.log('WatchUserFrom_SignUp.vue')
    //     this.$router.push('/timeline')
    //   }
    // },
    menu (val) {
      val && this.$nextTick(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
    error () {
      if (this.error) {
        this.signupError = true
        this.signUpErrorMessage = this.error.message
      }
    },
  },

  mounted() {
    var self = this


    self.autocomplete = new google.maps.places.Autocomplete(
      // (document.getElementById('autocomplete'))
      (document.querySelector('#autocomplete'))
      // ,
      // {
      //   // types: [
      //   //   // 'address'
      //   //   'geocode'
      //   // ]
      // }
    )

    self.autocomplete.setFields([
      'formatted_address',
      'geometry',
      'place_id'
    ])

    self.autocomplete.addListener('place_changed', () => {
      let place = self.autocomplete.getPlace()
      self.mylocationinput = place.formatted_address
      self.mylocation = place.formatted_address
      self.mycoordinates = {
        lat: place.geometry.location.lat(), 
        lng: place.geometry.location.lng()
      }
    })
  },

  methods: {
    ...mapMutations([
      'setLogin'
    ]),
    clickSignIn() {
     
      this.setLogin(true)
      setTimeout(() => {
        this.$vuetify.goTo(0, {
          duration: 100,
          offset: 0,
          easing: 'easeInOutQuint'
        })
      }, 33)
    },
    initGeolocator () {
      this.loadingGeolocate = true
      this.geolocateLocation()
    },

    initAutocomplete () {
      this.geolocateAutocomplete()
    },

    geolocateAutocomplete() {
      if (navigator.geolocation) {
        var self = this
        navigator.geolocation.getCurrentPosition(position => {
          var pos = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          }
          var circle = new google.maps.Circle({
            center: pos,
            radius: position.coords.accuracy
          })
          self.autocomplete.setBounds(circle.getBounds())
        })
      }
    },

    geolocateLocation() {
      if (navigator.geolocation) {
        var self = this
        navigator.geolocation.getCurrentPosition(position => {
          var pos = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          }
          self.reverseGeocoding(pos)
        })
      } else {
        self.loadingGeolocate = false
      }
    },



    reverseGeocoding(latLng) {
      var self = this

      if (self.geocoder === null) {
        self.geocoder = new google.maps.Geocoder
      } else {

      }

      self.geocoder.geocode({'location': latLng}, function(results, status) {
        if (status === 'OK') {
          self.loadingGeolocate = false

          if (results[0]) {
            self.loadingGeolocate = false

            // var location1 = results[0].formatted_address
            // console.log(results[0].formatted_address)
            self.mylocationinput = results[0].formatted_address
            self.mylocation = results[0].formatted_address
            self.mycoordinates = latLng
            console.log('mycoods', self.mycoordinates)

          } else {
            console.log('No results found')
            self.loadingGeolocate = false

            self.mylocationinput = 'No results found'
            self.mylocation = ''
            self.mycoordinates = ''
          }
        } else {
          console.log('Geocoder failed due to: ' + status)
          self.loadingGeolocate = false
          self.mylocationinput = 'Geocoder failed due to: ' + status
          self.mylocation = ''
          self.mycoordinates = ''
        }
      })
    },


    save (birthday) {
      this.$refs.dialog.save(birthday)
    },


    next() {
      switch (this.step) {
      case 1:
        if (!this.$v.name.$invalid && !this.$v.email.$invalid) {
          this.step++
          break
        } else {
          this.$v.name.$touch()
          this.$v.email.$touch()
          break
        }
      case 2:
        if (!this.$v.mylocationinput.$invalid &&
        !this.$v.mylocation.$invalid &&
        !this.$v.mycoordinates.$invalid && !this.$v.birthday.$invalid) {
          this.step++
          break
        } else {
          this.$v.mycoordinates.$touch()
          this.$v.birthday.$touch()
          break
        }
      case 3:
        if (!this.$v.password.$invalid &&
        !this.$v.confirmPassword.$invalid) {
          this.step++
          this.onSignup()
          break
        } else {
          this.$v.password.$touch()
          this.$v.confirmPassword.$touch()
          break
        }
        
      case 4:
        this.step = 1
        break
      }
      
    },
    goBack() {
      this.step = 1
      this.name = ''
      this.email = ''
      this.mylocationinput = ''
      this.mylocation = '' 
      this.mycoordinates = ''
      this.birthday = null
      this.displayBDay = true
      this.subscribeNewsletter = false
      this.showPw = false
      this.password = ''
      this.confirmPassword = ''
      this.$v.$reset()
      
      this.setLogin(true)
      setTimeout(() => {
        this.$vuetify.goTo(0, {
          duration: 100,
          offset: 0,
          easing: 'easeInOutQuint'
        })
      }, 33)


    },
    onSignup () {
      // Vuex
      if (!this.formIsValid)
      {
        this.$v.$touch()
      } else {
        const user = {
          name: this.name.replace(/\s\s+/g, ' '),
          email: this.email,
          password: this.password,
          birthday: this.birthday,
          displayBDay: this.displayBDay,
          subscribeNewsletter: this.subscribeNewsletter,
          location: this.mylocation,
          coordinates: this.mycoordinates,
          acceptTerms: true
        }
        this.$store.dispatch('signUserUp', user)
      }
    }
  },
}
</script>

<style scoped>
/* #cal {
  width: auto !important
} */
 .wevent_icon {
  margin-top: 12px;

  height: 60px !important;
  width: auto;
  -webkit-filter: invert(1) opacity(0.8);
  filter: invert(1) opacity(0.8);

  /* filter: invert(0.6) sepia(0.8) saturate(5) hue-rotate(330deg); */
}



</style>